import { ColorType } from '../global/Color.enum';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import { LabelType } from './Label.enum';
import type { ILabel } from './Label.interface';

export default class Label extends Root implements ILabel {
  name: string;
  type: LabelType;
  color: ColorType;
  isLocked: boolean;

  getName() {
    return this.name;
  }

  getColor() {
    return this.color?.name;
  }

  getTypeName() {
    return this.type?.title;
  }

  static build = (data: ILabel) => new Label(data);
  static blank = () => new Label({ isActive: true });

  /**
   * Constructor
   * @param {ILabel} data
   */
  constructor(data?: ILabel) {
    super(DocType.of('__definition.label'), data);

    this.name = data?.name || '';
    // TODO: data?.type is legacy data structure
    this.type = LabelType.of(data?.type?.name || data?.type);
    // TODO: data?.color?.id is legacy data structure
    this.color = ColorType.of(
      data?.color?.name
        ? data?.color?.name
        : `${data?.color?.id}_${data?.color?.variation || '500'}`
    );
    this.isLocked = data?.isLocked === true;
  }
}
